// Intercept internal liquid-ajax-cart events to prevent crashes when AJAX requests fail or abort.
// When a request fails, liquid-ajax-cart sets `responseData` to null.
// This patch runs before the library's internal listener to normalize it and avoid a TypeError.
document.addEventListener("liquid-ajax-cart:request-end-internal", (event) => {
  const { requestState } = event.detail;
  if (requestState && requestState.responseData === null) {
    requestState.responseData = {
      ok: false,
      status: 0,
      body: {}
    };
  }
});
